import { CircularProgress, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { CoinSponsorStatus } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { AuthenticationContext, useGeotokenSettings } from '../../../Contexts'
import { Property } from '../../Property'

const CoinSponsorStatusProperty: React.FC = () => {
  const settings = useGeotokenSettings()
  const { authEntity } = useContext(AuthenticationContext)
  const isAdmin = authEntity?.admin
  const coinSponsorStatus = settings?.getCoinSponsorStatus()

  const onChange = async (event: SelectChangeEvent<string>) => {
    const value = event.target.value as CoinSponsorStatus
    await settings?.setCoinSponsorStatus(value)
    await settings?.load(true)
  }

  return (
    <Property tip="Review status for COIN Sponsorship" title="COIN Status" value={coinSponsorStatus}>
      {settings ? (
        <Select disabled={isAdmin !== true} onChange={onChange} value={coinSponsorStatus} variant="standard">
          <MenuItem value={CoinSponsorStatus.Incomplete}>Incomplete</MenuItem>
          <MenuItem value={CoinSponsorStatus.Approved}>Approved</MenuItem>
          <MenuItem value={CoinSponsorStatus.Submitted}>Submitted</MenuItem>
          <MenuItem value={CoinSponsorStatus.Disapproved}>Disapproved</MenuItem>
        </Select>
      ) : (
        <CircularProgress size={24} />
      )}
    </Property>
  )
}

export default CoinSponsorStatusProperty
